/* eslint-disable arrow-return-style/arrow-return-style */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
import styled, { css } from 'styled-components'
import { ResponsiveImage } from '../ResponsiveImage/ResponsiveImage'

export const Container = styled.div<{
  scrollableImage: boolean
  isMobile: boolean
}>`
  width: 100vw;
  height: 100vh;
  height: var(--app-height);
  position: fixed;
  overflow: scroll;
  z-index: 10000;
  top: 0;
  left: 0;
  background-color: ${({ theme }) => theme.colors.backgroundOverlay};

  ${({ scrollableImage }) => {
    return (
      !scrollableImage &&
      css`
        display: flex;
        align-items: center;
        justify-content: center;
      `
    )
  }};

  opacity: 0;
  transition: opacity 0.1s;

  ${({ isMobile, scrollableImage }) => {
    return (
      !isMobile &&
      css`
        overflow: ${scrollableImage ? 'auto' : 'hidden'};
        opacity: 1;
        cursor: crosshair;
      `
    )
  }}
`

export const Image = styled(ResponsiveImage)<{
  scrollableImage: boolean
  isMobile: boolean
}>`
  width: ${({ width, isMobile }) =>
    width && !isMobile ? `${width}px` : 'auto'} !important;
  ${({ scrollableImage }) => {
    return scrollableImage
      ? css`
          display: block;
          margin: 0 auto;
        `
      : css`
          position: absolute;
        `
  }};

  ${({ isMobile }) => {
    return (
      isMobile &&
      css`
        opacity: 1;
        width: auto !important;
        height: 100vh;
        height: var(--app-height);
        left: 0;
      `
    )
  }}
`
